import React from 'react';
import Scrollbars from 'rc-scrollbars';
import './../../../Styles/Main/RentalPage/RentalRequestedStaff.scss'
import SwiperIcon from '../../../UI/swipericon/SwiperIcon';
import RentalRequestBike from './RentalRequestBike';
import MyButton from '../../../UI/button/MyButton';
import { BrowserRouter as Router, Routes, Route, Link, RouterProvider} from 'react-router-dom';
import { SelectedBike } from '../../../Constant/context';
import { useContext } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

function RentalRequestedStaff() {

   useEffect(() => {
      if (arrayOfBikes.length === 0) {
         setIsBikeSelected(false);
      }
   })

   const {selectedDateGlobal, selectedBikeGlobal, arrayOfBikes, } = useContext(SelectedBike)
   const [isBikeSelected, setIsBikeSelected] = useState(true);

   return (
      <div className='requestProcces__body'>
         <div className="requestProcces__date">
            <div className="requestProcces__column">
               <div className="requestProcces__signature signature">Type of rent</div>
               <div className="requestProcces__data text">{ selectedDateGlobal['typeRent'] }</div>
            </div>
            <div className="requestProcces__column">
               <div className="requestProcces__signature signature">Start date</div>
               <div className="requestProcces__data text">{ selectedDateGlobal['startDate'] }</div>
            </div>
            <div className="requestProcces__column">
               <div className="requestProcces__signature signature">Finish date</div>
               <div className="requestProcces__data text">{ selectedDateGlobal['finishDate'] }</div>
            </div>
            <div className="requestProcces__column">
               <div className="requestProcces__signature signature">Delivery</div>
               <div className="requestProcces__data text">{ selectedDateGlobal['delivery'] }</div>
            </div>
         </div>
         <div className="requestProcces__swipe">
            <SwiperIcon/>
         </div>
         <Scrollbars style={{ width: '100%', height: (60*arrayOfBikes.length)+100 }}>
            <div className="requestProcces__request-info">
               
               <div className="requestProcces__item-title">
                  <div className="requestProcces__columnName signature">Bike name</div>
                  <div className="requestProcces__columnName signature">Hemet</div>
                  <div className="requestProcces__columnName signature">Lights</div>
                  <div className="requestProcces__columnName signature">Lock</div>
                  <div className="requestProcces__columnName signature">Price</div>
               </div>
               {
                  isBikeSelected
                     ?
                     arrayOfBikes.map((item, index) => (
                        <div
                           key={index}
                           className="requestProcces__item"
                        >
                           <RentalRequestBike
                              name={item['name']}
                              price={item['price']}
                              image={item['picture']}
                           />
                        </div>
                     ))
                     :
                     <div className="requestProcces__message text">
                        Bicycles not selected
                     </div>
               }
            </div>
         </Scrollbars>
         <div className="requestProcces__summary">
            <div className="requestProcces__back">
               <Link to='/rental'>
                  <MyButton
                     style={{ fontSize: '16px', fontWeight: '700' }}

                  >Back to bikes
                  </MyButton>
               </Link>
            </div>
            <div className="requestProcces__cashSum">
               <div className="requestProcces__titleDelivery requestProcces__cashItem signature">Delivery:</div>
               <div className="requestProcces__titleSum requestProcces__cashItem signature">Total:</div>
               <div className="requestProcces__costDelivery requestProcces__cashItem color-text">0 USD</div>
               <div className="requestProcces__costSum requestProcces__cashItem color-text">{ `${selectedDateGlobal['sumPrice']} USD` }</div>
            </div>
         </div>
      </div>
   );
}
export default RentalRequestedStaff;